module.exports = __webpack_public_path__ + "img/icon-05.99b04821.svg";